var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import FilterTextInput from "./FilterTextInput";
import FilterDatePicker from "./FilterDatePicker";
import FilterMultiSelect from "./FilterMultiSelect";
import FilterBoolean from "./FilterBoolean";
function Filter(props) {
    switch (props.type) {
        case 'str':
        case 'int':
        case 'float':
            return (_jsx(FilterTextInput, __assign({}, props)));
        case 'datetime':
            return (_jsx(FilterDatePicker, __assign({}, props)));
        case 'boolean':
            return (_jsx(FilterBoolean, __assign({}, props)));
        case 'multi':
            return (_jsx(FilterMultiSelect, __assign({}, props)));
    }
    console.log('Cannot retrieve filter type: ' + props.attribute);
    return _jsx(_Fragment, {});
}
export default Filter;
